// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1HTjS","rightAdornment":"Header_rightAdornment__2onzn"};